import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "17", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "9 6 3 12 9 18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 19V5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowLeftFromLine";
const ArrowLeftFromLine = memo(themed(Icon));
export {
  ArrowLeftFromLine
};
//# sourceMappingURL=arrow-left-from-line.js.map
